module.exports = __webpack_public_path__ + "static/media/react-native.72cccc0c.png";